export default {
  title: 'System Notification',
  menu: 'System Notification',
  label: {
    datetime: 'Create Time',
    company: 'Company',
    includeSubCompanies: 'Include Sub-Companies?',
    includeExclude: 'Include/Exclude?',
    messageTitle: 'Message Title',
    addNewNotification: 'Add new notification',
    viewNotification: 'View notification',
    view: 'View',
    allCompanies: 'All companies',
    yes: 'yes',
    no: 'no',
    excludeCompanies: 'Exclude',
    includeCompanies: 'Include',
    sendSystemNotification: 'Send system notification',
    viewSystemNotification: 'View system notification',
    visibleCompanies: 'Visible Companies',
    includeSubCompaniesLabel: 'Include Sub-Companies?',
    messageTemplate: 'Message Template'
  },
  placeholder: {
    keywords: 'Search (notification content)',
    searchCompany: 'Search for a company by title'
  },
  message: {
    saveSiteMessageSuccess: 'Save notification success',
    saveSiteMessageFail: 'Save notification fail'
  }
}
